import { render, staticRenderFns } from "./CurationFilterRequestFilter.vue?vue&type=template&id=79938e8e&scoped=true"
import script from "./CurationFilterRequestFilter.vue?vue&type=script&lang=js"
export * from "./CurationFilterRequestFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79938e8e",
  null
  
)

export default component.exports